import { Injectable, LOCALE_ID, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CurrencyFormatService {
  readonly #locale = inject(LOCALE_ID);

  public format(value: number | null | undefined, currency: string | null | undefined, digitsInfo = '1.0-2'): string {
    if (value === null || value === undefined || !currency) {
      return '';
    }

    const [, minimumFractionDigits, maximumFractionDigits] = /\d+\.(\d+)-(\d+)/.exec(digitsInfo) ?? [];
    return new Intl.NumberFormat(this.#locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: Number(minimumFractionDigits),
      maximumFractionDigits: Number(maximumFractionDigits),
    }).format(value);
  }

  public symbol(currency: string | null | undefined): string {
    if (!currency) {
      return '';
    }

    return (
      new Intl.NumberFormat(this.#locale, { style: 'currency', currency }).formatToParts(0).find((part) => part.type === 'currency')
        ?.value ?? currency
    );
  }

  public minorUnitLabel(currency: string | null | undefined): string {
    switch (currency) {
      case 'GBP':
        return 'p';
      case 'AUD':
        return 'c';
      default:
        return currency ?? '';
    }
  }
}
